import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../config';

export default class extends React.Component {

  state = {
    positive: false,
    negative: false
  };

  constructor(props) {
    super(props);

    Config.setGroup(props.match.params.group);
  }

  render() {
    return (
      <div className="content-inner-container landing">
        <div className="landing-inner">
          <p>
            Please take a moment to review your experience with us.
            Your feedback not only helps us, it helps other potential clients.
          </p>
          <div className="rank-container">
            <div className="rank rank-up" onClick={() => this.setState({ positive: true })}>
              <i className="fa fa-smile-o" />
              <p>I had a good experience</p>
            </div>
            <div className="rank rank-down" onClick={() => this.setState({ negative: true })}>
              <i className="fa fa-meh-o" />
              <p>I had a bad experience</p>
            </div>
          </div>
        </div>
        {
          this.state.negative ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/feedback`} />
          ) : null
        }
        {
          this.state.positive ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you`} />
          ) : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/states/landing/index.js